import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useSnackBar from '../../../../../hooks/useSnackBar/useSnackBar';
import useHttpError from '../../../../../hooks/useHttpError/useHttpError';

import UemOnboardingService from '../../../../../services/UemOnboarding/UemOnboardingService';
import UsersService from '../../../../../services/Users/UsersService';

import { AddDeviceRequest } from '../../../../../models/UserDevicesModels';
import { UemCompany } from '../../../../../models/UemOnboardingModels';

import { DropdownItem } from '../../../../../components/Dropdown/DropdownModels';

function useAddDevice(onClose: () => void, onAddDeviceSuccess: () => void, unassignedReport?: boolean) {
  const snackBar = useSnackBar();
  const [t] = useTranslation();
  const { getHttpReason } = useHttpError();
  const [isLoading, setIsLoading] = useState(false);
  const [companyOptions, setCompanyOptions] = useState<DropdownItem[]>([]);
  const [companies, setCompanies] = useState<UemCompany[]>([]);

  useEffect(() => {
    if (!unassignedReport) {
      return;
    }

    UemOnboardingService.api.fetchCompanies().then(
      (response) => {
        setCompanies(response.data.companies);
        setCompanyOptions(
          response.data.companies.map((obj) => ({
            key: obj.id,
            value: obj.id,
            label: `${obj.name} ${obj.country}`,
          })),
        );
      },
      () => {
        snackBar.showSnackBar(t('pages.eSimManager.newUserDrawer.fetchCompaniesError'), 'error');
      },
    );
  }, [unassignedReport]);

  /**
   * Adds a new device
   * @param req
   * @param errorCallback
   */
  const addDevice = async (req: AddDeviceRequest) => {
    UsersService.api.addDevice(req).then(
      () => {
        snackBar.showSnackBar(t('pages.addDeviceDrawer.addDeviceSuccess'), 'success');
        onClose();
        onAddDeviceSuccess();
        setIsLoading(false);
      },
      (res) => {
        setIsLoading(false);
        const error = getHttpReason(res.response.data, t('pages.addDeviceDrawer.addDeviceError'));
        snackBar.showSnackBar(error, 'error');
      },
    );
  };

  return { isLoading, addDevice, companyOptions, companies };
}

export default useAddDevice;
